import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Tag, Button, Spin, Space } from 'antd';
import ApiService from '../Components/apiService'; 
import { BASE_URL } from '../Components/Constant';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';  // Import dayjs for formatting

const MyTask = () => {
  const [loading, setLoading] = useState(true);
  const [myTask, setMyTask ] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const userId = Cookies.get('userId');

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    
    const options = { 
      day: '2-digit', month: 'long', year: 'numeric', 
      hour: '2-digit', minute: '2-digit', hour12: true 
    };
    
    return date.toLocaleString('en-GB', options);
  };

  // Columns for the table
  const columns = [
    {
        title: 'Subject',
        dataIndex: 'Subject',
        key: 'subject',
        render: (text, record) => (
          <a 
            onClick={() => navigate(`/record/Activity/${record._id}`)} 
            style={{ color: '#1890ff', cursor: 'pointer' }}
          >
            {text}
          </a>
        ),
    },
    {
      title: 'Related To',
      dataIndex: 'AssociatedObject',
      key: 'AssociatedObject',
  },
    {
      title: 'Due Date',
      dataIndex: 'EndDateTime',
      key: 'endDateTime',
      render: (text) => formatDateTime(text),

    },
    {
        title: 'Priority',
        dataIndex: 'Priority',
        key: 'priority',
        render: (status) => {
          let color = 'blue';
          if (status === 'Low') color = 'green';
          else if (status === 'Medium') color = 'blue';
          else if (status === 'High') color = 'red';
          return <Tag color={color}>{status.toUpperCase()}</Tag>;
        },
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'status',
      render: (status) => {
        let color = 'blue';
        if (status === 'Approved') color = 'green';
        else if (status === 'Pending') color = 'orange';
        else if (status === 'Rejected') color = 'red';
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },
  ];

  // Fetch approval requests from the API
  useEffect(() => {
    const fetchActivityTask = async () => {
      try {

        const body = {
          object_name: 'Activity',
          filters: {
            ActivityType: 'Task',
            Status: 'Pending'
          }
        };

        const apiService = new ApiService(`${BASE_URL}/fetch_object_records`, {
          'Content-Type': 'application/json',
        }, 'POST',
        body
      );
  
        const response = await apiService.makeCall();
  
        // Filtering response based on conditions
        const pendingTask = response.filter(item =>  
          item.CreatedBy_id === userId
        );
  
        setMyTask(pendingTask);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchActivityTask();
  }, [userId]);  // Dependency array ensures it updates when userId changes
  



  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }} className="non-draggable">
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Spin spinning={loading} >
          <Table
            columns={columns}
            dataSource={myTask}
            rowKey="_id"
            pagination={{
              current: currentPage,
              showSizeChanger: false,
              onChange: (page, pageSize) => {
                setCurrentPage(page); 
              },              
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }} 
            scroll={{ y: 180 }}
          />
        </Spin>
    </div>
  </div>
  );
};

export default MyTask;
